export default {
  remote: 'sro_portal',
  name: 'sro-portal',
  urlMapping: {
    localhost: 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1003014769/sro-portal/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1003014769/sro-portal/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1003014769/sro-portal/v1/mf2/mf-manifest.json',
  },
};
